import { createSelector, MemoizedSelector } from '@ngrx/store';
import { Ticket } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { ProductState, StateWithProduct } from '../product-state';
import { getCustomProductState } from './feature.selector';

export const getTicketState: MemoizedSelector<StateWithProduct, StateUtils.LoaderState<Ticket>> = createSelector(
  getCustomProductState,
  (state: ProductState) => state.ticket,
);

export const getTicketLoading: MemoizedSelector<StateWithProduct, boolean> = createSelector(
  getTicketState,
  (state: StateUtils.LoaderState<Ticket>) => StateUtils.loaderLoadingSelector(state),
);

export const getTicketError: MemoizedSelector<StateWithProduct, boolean> = createSelector(
  getTicketState,
  (state: StateUtils.LoaderState<Ticket>) => StateUtils.loaderErrorSelector(state),
);

export const getTicketSuccess: MemoizedSelector<StateWithProduct, boolean> = createSelector(
  getTicketState,
  (state: StateUtils.LoaderState<Ticket>) => StateUtils.loaderSuccessSelector(state),
);
